import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { StorefrontHeaderView } from 'marketplace-ui-common/storefront/components/StorefrontHeaderView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HeaderSection() {
  return /*#__PURE__*/_jsx(StorefrontHeaderView, {
    as: "header",
    color: "orange",
    "data-test-id": "storefront-header",
    gradientAngle: 225,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      gap: "400",
      paddingBlock: "1200",
      paddingInline: "800",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        use: "on-dark",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.pageTitle"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "heading-200",
        use: "on-dark",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.pageSubtitle"
        })
      })]
    })
  });
}